import pathify from 'vuex-pathify';

pathify.options.mapping = 'simple';
pathify.options.deep = 2;

export default pathify;
